var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z","key":1})]);
}

CheckInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
